import {addEventOnDesktopGuideLayer, loadDesktopGuideLayer} from "./render";

const {isFunc} = Mutil;

export const DesktopGuide = (() => {
    return {
        addEventOnDesktopGuideLayer: addEventOnDesktopGuideLayer,
        initDesktopGuide(callback) {
            const isFuncDesktopGuide = isFunc("DESKTOP_GUIDE") || window.isShowdesktopGuide;
            if(!isFuncDesktopGuide) {
                (typeof callback === "function") && callback();
                return;
            }
            loadDesktopGuideLayer(callback);
        },
    }
})();